import { $qs , $qsa } from "./utils/querySelector"
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

function admissionsProcess() {
    if($qs('body').classList.contains('page-template-admissions-process')) {
        window.onbeforeunload = function () {
            window.scrollTo(0, 0);
          }        
        var panelLength = $qs('[data-target="admissions-slider-steps"]').offsetWidth;
        var fadedBg = $qs('.js-admissions-process-bg');
        var title = $qs('[data-target=js-admissions-process-title]');
        var intro = $qs('[data-target=js-admissions-process-intro]');
        var bottomTabs = $qs('[data-target=admissions-process-bottom-tabs]');
        var scrollInstruction = $qs('[data-target=js-admissions-process-scroll-instruction');
        var tabs = $qsa('[role=tab]');
        var scrollable = false; 
        if(scrollable == false) {
            window.addEventListener('wheel', () => {                
                var scrollAttempts = $qsa('#scroll-attempt');
                scrollAttempts.forEach((scrollAttempt) => {
                    scrollAttempt.style["boxShadow"] = '0 0 90px #6CACE4';
                    setTimeout(() => {
                        scrollAttempt.style["boxShadow"] = '0 0 0px #6CACE400';
                    }, 300)
                })
            })
        }
        tabs.forEach((tab) => {
            tab.addEventListener('click', () => {
                // if(tab.getAttribute('aria-selected') == true) {
                    scrollable = true;
                    gsap.to('body', {
                        overflow: 'visible'
                    })
                // }  
            })           
        } )

        var apTL = gsap.timeline({				
            scrollTrigger: {
                trigger: '.js-admissions-process-container',
                scrub: 0.2,
                pin: '.js-admissions-process-pin',
                start: "bottom bottom",
                end: panelLength,    
                // markers: true    ,
                onEnterBack: () => {
                    // if(window.innerWidth > 991) {
                    gsap.to(fadedBg, {
                        opacity: 0.95,  
                        duration: 0.4              
                    })
                    // }
                    gsap.to(title, {
                        opacity: 0,  
                        duration: 0.4              
                    })
                    gsap.to(intro, {
                        opacity: 0,  
                        duration: 0.4              
                    }, "<")
                    gsap.to(scrollInstruction, {
                        opacity: 1,
                        duration: 0.4
                    })
                    gsap.to(bottomTabs, {
                        opacity: 1,
                        duration: 0.05
                    }, "<")
                    gsap.to(bottomTabs, {
                        yPercent: 0,
                        duration: 1,
                        ease: "power4.out"
                    })
                },
                onLeave: () => {
                    // gsap.to(fadedBg, {
                    //     opacity: 0,  
                    //     duration: 0.4              
                    // })
                    gsap.to(bottomTabs, {
                        yPercent: -100,
                        duration: 1,
                        ease: "power4.out"
                    })
                    gsap.to(bottomTabs, {
                        opacity: 0,
                        duration: 0.05
                    })
                },
                onLeaveBack: () => {
                    gsap.to(bottomTabs, {
                        yPercent: -100,
                        duration: 1,
                        ease: "power4.out"
                    })
                    gsap.to(bottomTabs, {
                        opacity: 0,
                        duration: 0.05
                    })
                    gsap.to(scrollInstruction, {
                        opacity: 0,
                        duration: 0.4
                    },"<")
                    // if(window.innerWidth > 991) {
                    gsap.to(fadedBg, {
                        opacity: 0,  
                        duration: 0.4              
                    })
                    // }
                    gsap.to(title, {
                        opacity: 1,  
                        duration: 0.4              
                    })
                    gsap.to(intro, {
                        opacity: 1,  
                        duration: 0.4              
                    }, "<")
                },
                onEnter: () => {
                    gsap.to(bottomTabs, {
                        opacity: 1,
                        duration: 0.05
                    })
                    gsap.to(bottomTabs, {
                        yPercent: 0,
                        duration: 1,
                        ease: "power4.out"
                    })
                    gsap.to(scrollInstruction, {
                        opacity: 1,
                        duration: 0.4
                    })
                    // if(window.innerWidth > 991) {
                    gsap.to(fadedBg, {
                        opacity: 0.95,  
                        duration: 0.4              
                    })
                    // }
                    gsap.to(title, {
                        opacity: 0,  
                        duration: 0.4              
                    })
                    gsap.to(intro, {
                        opacity: 0,  
                        duration: 0.4              
                    }, "<")
                },		                
            },	
            // onStart: () => {

            //     gsap.to(fadedBg, {
            //         opacity: 0.8,  
            //         duration: 0.4              
            //     })
            // },					
            // onComplete: () => {

            //     gsap.to(fadedBg, {
            //         opacity: 0,  
            //         duration: 0.4              
            //     })
            // },


        });

        apTL.pause;    
        apTL.to('[data-target="admissions-slider-steps"]', {
            x: -200,
        })
        var tabs = $qsa('[role=tab]');


        [...tabs].forEach((tab) => {
            tab.addEventListener('click', () => {
                // apTL.progress(0);            
                // apTL.pause;    
                // gsap.to(window, { duration: 0.5, scrollTo: 0 });

                if(window.matchMedia("(min-width: 750px)").matches) {
                    var clickedPanel = document.getElementById(tab.getAttribute('aria-controls'));
                    var thisPanelLength = clickedPanel.offsetWidth;
                    var panelCount = (clickedPanel.children)[0].childElementCount
                    console.log(window.innerWidth * (1 / thisPanelLength) * 100)
                    gsap.to(window, { duration: 0.5, scrollTo: window.innerWidth * (1 / thisPanelLength) * 2000 });
                } else {                    
                    gsap.to(window, { duration: 0.5, scrollTo: window.innerHeight * 0.8 });
                }

                apTL.play;
                // apTL.progress(0.1);          
             

            })        
        })

    }
}

export default admissionsProcess;